/**
 * My IP address
 * ====================================
 * TODO Fix or remove hostname
 * TODO IPv6
 * TODO Добавить браузер, ОС
 * TODO Добавить местоположение
 * TODO random ip address generator (3K трафик)
 *    random ip address (6K трафик)
 *    fake ip address generator 1.9К
 */
import { LoaderFunctionArgs, MetaFunction } from "react-router";
import { useLoaderData, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import invariant from "tiny-invariant";

import H2 from "~/components/H2";
import AdditionalInfo from "~/components/tool-page/AdditionalInfo";
import AdditionalInfoSection from "~/components/tool-page/AdditionalInfoSection";
import ToolHeader from "~/components/tool-page/ToolHeader";
import { getClientIPAddress } from "~/helpers/get-client-ip-address.server";
import { makeTitle } from "~/helpers/pageTitle";
import { createArticleSchema } from "~/helpers/schemaOrg";
import { getLocale } from "~/i18n";
import { getTranslator } from "~/i18next.server";

const CATEGORY = "tools";
const TKEY = "myip";
const ROUTE_ENDING = "myip";
const LAST_UPDATED = new Date("2024-05-01T00:00:00.000Z");


export const meta: MetaFunction<typeof loader> = ({ data }) => [
  { title: makeTitle(data?.meta.title) },
  { name: "description", content: data?.meta.description },
  createArticleSchema(
    data?.meta.locale as string,
    data?.meta.title as string,
    [],
    LAST_UPDATED
  )
];

export const handle = {
  localisedLinks: ["en", "ru", "de", "fr", "es", "it", "pt"],
  i18n: ["tools"]
};


export const loader = async ({ request }: LoaderFunctionArgs) => {
  const locale = getLocale(request.url) ?? "";

  const t = await getTranslator(request, "tools");

  const breadcrumbs = [
    { title: `catalog.categories.${CATEGORY}`, to: `${CATEGORY}` },
    { title: `calculators.tools.${TKEY}.title`, to: `${CATEGORY}/${ROUTE_ENDING}` }
  ];

  return {
    result: {
      ip: getClientIPAddress(request) ?? t(`${TKEY}.not_detected`),
      hostname: request.headers.get("Host") || null
    },
    meta: {
      locale,
      title: t(`${TKEY}.title`),
      description: t(`${TKEY}.description`),
      breadcrumbs
    }
  };
};

export default function Index() {
  const {
    meta,
    result
  } = useLoaderData<typeof loader>();

  const { t } = useTranslation("tools");
  const locale = getLocale(useLocation().pathname);
  invariant(locale);

  return (
    <>
      <ToolHeader
        name={meta.title}
        description={meta.description}
      />

      <div
        className="py-6 w-full flex flex-col md:gap-4 justify-center items-center font-extrabold uppercase text-slate-900 dark:text-white"
      >
        <div className="text-[1.7rem] md:text-[2.5rem] text-slate-600 dark:text-slate-100">
          {t(`${TKEY}.your_ip`)}
        </div>
        <div className="text-[2.5rem] md:text-[4rem] uppercase dark:text-yellow-300">
          {result.ip}
        </div>
      </div>

      <div
        className="py-6 w-full flex flex-col md:gap-4 justify-center items-center font-extrabold uppercase text-slate-900 dark:text-white"
      >
        <div className="text-[1.5rem] md:text-[2rem] text-slate-600 dark:text-slate-100">
          {t(`${TKEY}.your_hostname`)}
        </div>
        {/* TODO This is wrong */}
        {/*<div className="text-[1.8rem] md:text-[2.5rem] uppercase dark:text-yellow-300">*/}
        {/*  {result.hostname}*/}
        {/*</div>*/}
      </div>

      <AdditionalInfo>
        <AdditionalInfoSection>
          <H2>{t(`${TKEY}.info_how_h`)}</H2>
          <p>{t(`${TKEY}.info_how_p1`)}</p>
          <p>{t(`${TKEY}.info_how_p2`)}</p>

          <ul className="list-ol">
            <li>X-Client-IP</li>
            <li>X-Forwarded-For</li>
            <li>HTTP-X-Forwarded-For</li>
            <li>Fly-Client-IP</li>
            <li>CF-Connecting-IP</li>
            <li>Fastly-Client-Ip</li>
            <li>True-Client-Ip</li>
            <li>X-Real-IP</li>
            <li>X-Cluster-Client-IP</li>
            <li>X-Forwarded</li>
            <li>Forwarded-For</li>
            <li>Forwarded</li>
            <li>DO-Connecting-IP</li>
            <li>oxygen-buyer-ip</li>
          </ul>
        </AdditionalInfoSection>

        <AdditionalInfoSection>
          <H2>{t(`${TKEY}.info_why_h`)}</H2>
          <p>{t(`${TKEY}.info_why_p1`)}</p>
          <p>{t(`${TKEY}.info_why_p2`)}</p>
          <p>{t(`${TKEY}.info_why_p3`)}</p>
        </AdditionalInfoSection>
      </AdditionalInfo>
    </>
  )
    ;
}


